exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".st0{\n\tfill-rule:evenodd;\n\tclip-rule:evenodd;\n\tfill:#635BFF;\n}", ""]);
